// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"438":"5e34b6f4","3307":"da94e0f0","8168":"6c3e1a7c"}[chunkId] + ".chunk.css";
};